const initSwiperBanner = () => {
    const swipers = document.querySelectorAll('.js-swiper-banner');
    for( let i = 0; i < swipers.length; i++ ) {
        const swiperWrapper = swipers[i].querySelector('.swiper');

        swiperWrapper.classList.add('js-swiper-banner-' + i);
        const buttonPrev = swipers[i].querySelector('.swiper-button-prev');
        const buttonNext = swipers[i].querySelector('.swiper-button-next');

        let slidesPerView = 1;

        const swiper = new Swiper('.js-swiper-banner-' + i, {
            direction: 'horizontal', 
            spaceBetween: 0,
            slidesPerView: slidesPerView,
            loop: true,
            grabCursor: true,
            simulateTouch: true,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            }
        });
    }
}

const initSwiperCards = () => {
    const swipers = document.querySelectorAll('.js-swiper-cards');
    for( let i = 0; i < swipers.length; i++ ) {
        const swiperWrapper = swipers[i].querySelector('.swiper');

        swiperWrapper.classList.add('js-swiper-cards-' + i);
        const buttonPrev = swipers[i].querySelector('.swiper-button-prev');
        const buttonNext = swipers[i].querySelector('.swiper-button-next');

        let desktopSlidesPerView = swipers[i].dataset.desktopSlides;
        let tabletSlidesPerView = swipers[i].dataset.tabletSlides;
        let desktopSpaceBetween = swipers[i].dataset.desktopGap;
        let tabletSpaceBetween = swipers[i].dataset.tabletGap;

        const swiper = new Swiper('.js-swiper-cards-' + i, {
            direction: 'horizontal', 
            spaceBetween: 0,
            slidesPerView: 1,
            loop: true,
            grabCursor: true,
            simulateTouch: true,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            breakpoints: {
                1024: {
                    slidesPerView: desktopSlidesPerView,
                    spaceBetween: desktopSpaceBetween,
                },
                782: {
                    slidesPerView: tabletSlidesPerView,
                    spaceBetween: tabletSpaceBetween,
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initSwiperBanner();
    initSwiperCards();
});